import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Cpu.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "CpuIcon";
const s = e;
export {
  s as Cpu,
  e as CpuIcon
};
